import React, { useRef } from "react";
import { Grid, TextField } from "@material-ui/core";
import {
  SET_START_SCAN_TIME,
  SET_END_SCAN_TIME,
  NTFS_LOCAL,
} from "../dataSourceConstants";
import "./NTFSScanTimeRange.scss";
import { Typography } from "@material-ui/core";
import { ScanTimeDescription, ScanTimeExample } from "../../NTFS/ntfsConstants";
import ImageTooltip from "../../../common/HelpIconWithTooltip";

const NTFSScanTimeRange = ({
  startTime,
  endTime,
  dispatch,
  removeErrorByKey,
  error,
  classes,
}) => {
  const startTimeRef = useRef(null);
  const endTimeRef = useRef(null);

  const handleChange = (type) => (event) => {
    dispatch({
      type,
      payload: event.target.value,
    });
  };

  const styledDescription = (
    <Typography>
      <span className={classes.tooltipHeading}>{ScanTimeDescription}</span>
      <br />
      <span className={classes.tooltipExample}>{ScanTimeExample}</span>
    </Typography>
  );

  const openStartPicker = () => {
    startTimeRef.current?.showPicker?.();
  };

  const openEndPicker = () => {
    endTimeRef.current?.showPicker?.();
  };

  return (
    <div className="ntfs-scan-time-range">
      {/* Title OUTSIDE border */}
      <div className={classes.tooltipContainer}>
        <div className="ntfs-scan-time-title">Scan Schedule</div>
        <ImageTooltip description={styledDescription} loc={NTFS_LOCAL} />
      </div>

      <Grid container spacing={2}>
        {/* Start Time */}
        <Grid item>
          <div className="time-field-container">
            <div className="time-field-label">Start Scan Time</div>
            <div className="time-field-wrapper">
              <TextField
                type="time"
                value={startTime || ""}
                inputRef={startTimeRef}
                onClick={openStartPicker}
                onChange={handleChange(SET_START_SCAN_TIME)}
                inputProps={{ step: 300 }}
                error={!!error.startScanTime}
                helperText={error.startScanTime}
                onBlur={() => removeErrorByKey("startScanTime")}
                className="ntfs-time-field"
                fullWidth
              />
            </div>
          </div>
        </Grid>

        {/* End Time */}
        <Grid item>
          <div className="time-field-container">
            <div className="time-field-label">End Scan Time</div>
            <div className="time-field-wrapper">
              <TextField
                type="time"
                value={endTime || ""}
                inputRef={endTimeRef}
                onClick={openEndPicker}
                onChange={handleChange(SET_END_SCAN_TIME)}
                inputProps={{ step: 300 }}
                error={!!error.endScanTime}
                helperText={error.endScanTime}
                onBlur={() => removeErrorByKey("endScanTime")}
                className="ntfs-time-field"
                fullWidth
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NTFSScanTimeRange;
